import { Modal } from './Modal'
import React, { FC, useEffect, useState } from 'react'
import closeX from '@mortgage-pos/ui/assets/closing-x.svg'
import whiteCloseX from '@mortgage-pos/ui/assets/closing-x-white.svg'
import infoModalCopy from '@mortgage-pos/ui/data/infoModalData'

interface Props {
  onClose: () => void
  modalVariant?: string
}

const InfoModal: FC<Props> = ({ onClose, modalVariant = 'definitions' }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }, [])

  const [isHovered, setIsHovered] = useState(false)

  return (
    <Modal>
      <div className="info-modal__close-button">
        <button className="" onClick={onClose} type="button">
          <img
            className="loan-officer-modal__close-button-icon"
            src={isHovered ? whiteCloseX : closeX}
            alt="close icon"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          />
        </button>
      </div>

      <div className="info-modal">
        {infoModalCopy[modalVariant]?.map((modalItem) => (
          <div key={modalItem.heading}>
            <h2 className="info-modal__heading">{modalItem.heading}</h2>
            <h3 className="info-modal__blurb">{modalItem.description}</h3>
          </div>
        ))}
      </div>
    </Modal>
  )
}

export default InfoModal
